module.exports = __webpack_public_path__ + "static/media/cloud-d2-v3@2x.4016c7b1.png";